import {
  UPDATE_ACCOUNT_INFO_IN_PROGRESS,
  UPDATE_ACCOUNT_INFO_SUCCESS,
  UPDATE_ACCOUNT_INFO_ERROR,
  DISMISS_STATUS_MESSAGE,
} from "./actionTypes";

import axios from "axios";

const updateAccountInfoAction = (url, data) => {
  return async (dispatch, getState) => {
    dispatch({
      type: UPDATE_ACCOUNT_INFO_IN_PROGRESS,
    });

    if (!data.firstName) {
      dispatch({
        type: UPDATE_ACCOUNT_INFO_ERROR,
        payload: {
          status: "error",
          message: "First name is required.",
        },
      });
    } else if (!data.lastName) {
      dispatch({
        type: UPDATE_ACCOUNT_INFO_ERROR,
        payload: {
          status: "error",
          message: "Last name is required.",
        },
      });
    } else if (!data.dob) {
      dispatch({
        type: UPDATE_ACCOUNT_INFO_ERROR,
        payload: {
          status: "error",
          message: "Date of birth is required.",
        },
      });
    } else {
      try {
        let response = await axios({
          url,
          method: "POST",
          data,
        });
        console.log(response);
        if (response.data) {
          dispatch({
            type: UPDATE_ACCOUNT_INFO_SUCCESS,
            payload: {
              user: response.data.user,
              auth: response.data.auth,
            },
          });
        }
      } catch (error) {
        dispatch({
          type: UPDATE_ACCOUNT_INFO_ERROR,
          payload: {
            status: "error",
            message: error.response.data,
          },
        });
      }
    }

    setTimeout(() => {
      dispatch({
        type: DISMISS_STATUS_MESSAGE,
      });
    }, 10000);
  };
};

export default updateAccountInfoAction;
